/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsPerDateDto } from '../../models/submissions-per-date-dto';

export interface DashboardSubmissionsPerDateGet$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardSubmissionsPerDateGet(http: HttpClient, rootUrl: string, params?: DashboardSubmissionsPerDateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsPerDateDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardSubmissionsPerDateGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsPerDateDto>>;
    })
  );
}

dashboardSubmissionsPerDateGet.PATH = '/Dashboard/submissions-per-date';
